/**
 * tolling-api v2
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ActivityCorrectionValuesResponseDto } from './activityCorrectionValuesResponse';

export interface ActivityCorrectionElementResponseDto {
    type?: ActivityCorrectionElementResponseDto.TypeEnum;
    data?: ActivityCorrectionValuesResponseDto;
}
export namespace ActivityCorrectionElementResponseDto {
    export const TypeEnum = {
        TotalAmount: 'TOTAL_AMOUNT',
        EntryPlaza: 'ENTRY_PLAZA',
        ExitPlaza: 'EXIT_PLAZA',
        Facility: 'FACILITY',
    } as const;
    export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];
}
